module.exports = __webpack_public_path__ + "static/media/flag-france.53caea14.svg";